import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

import classes from './CarouselContainer.module.css';

const CarouselContainer = () => {
  return (
    <div className={classes.carouselContainer}>
      <aside className={classes.bannerTextContainer}>
        <p className={classes.title}>Enseña con Mayahii</p>
        <p className={classes.text}>
          Crea cursos y hazlos llegar a todo el mundo. Transforma tus
          conocimientos y habilidades en un sólido negocio de
          capacitación.
        </p>
      </aside>
      <Carousel
        autoPlay
        dynamicHeight
        infiniteLoop
        showArrows={false}
        showStatus={false}
        showThumbs={false}
      >
        <div>
          <img
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/Slider01.jpg"
            alt="banner"
          />
        </div>
        <div>
          <img
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/Slider02.png"
            alt="banner"
          />
        </div>
      </Carousel>
    </div>
  );
};

export default CarouselContainer;
